<template>
  <b-row class="body">
    <b-col cols="12" class="mx-auto error-page">
      <h1 class="text-error text-center">
        {{ text }}
      </h1>
      <a @click.prevent="goHome()"
         href="#"
         class="text-link">
        {{ link }}
      </a>
    </b-col>
  </b-row>
</template>

<script>
import controller from './controller'
const { script } = controller()
export default script
</script>

<style
    lang="scss"
    scoped
    src="./styles.scss" />
